<template>
  <div>
    <div class="section1">
      <img
        :src="bgImg ? bgImg : require('../../static/images/aboutUs/bg.jpg')"
        alt
      />
      <div class="auBox">{{ isChinese ? "关于计氏" : "About JiShi" }}</div>
    </div>

    <div class="section2">
      <p>{{ isChinese ? section1Obj.context1 : section1Obj.context1En }}</p>
      <p>{{ isChinese ? section1Obj.context2 : section1Obj.context2En }}</p>
      <p>{{ isChinese ? section1Obj.context3 : section1Obj.context3En }}</p>
      <div class="scrllrBox" id="num">
        <div>
          <p>
            <countTo
              ref="mynum"
              :startVal="0"
              :endVal="section1Obj ? Number(section1Obj.context4) : 0"
              :duration="5000"
            ></countTo>
          </p>
          <p>{{ isChinese ? "创始于" : "Founded in" }}</p>
        </div>
        <div class="shu"></div>
        <div>
          <p>
            <countTo
              ref="mynum1"
              :startVal="0"
              :endVal="section1Obj ? Number(section1Obj.context5) : 0"
              :duration="5000"
            ></countTo
            >+
          </p>
          <p>{{ isChinese ? "名企业职员" : "Employees" }}</p>
        </div>
        <div class="shu"></div>

        <div>
          <p>
            <countTo
              ref="mynum2"
              :startVal="0"
              :endVal="section1Obj ? Number(section1Obj.context6) : 0"
              :duration="8000"
            ></countTo>
          </p>
          <p>{{ isChinese ? "个生产基地" : "Production bases" }}</p>
        </div>
      </div>
    </div>

    <div class="section3">
      <div class="bbTitl">
        {{ isChinese ? "我们的生产基地" : "Our Production Base" }}
      </div>
      <template>
        <div class="hoverBox">
          <div class="hoverBox_left">
            <img :src="shengchanImg" alt />
            <!-- 文字介绍 -->
            <div class="innerText">
              <p>{{ isChinese ? shengchanData.key : shengchanData.keyEn }}</p>
              <div class="heng"></div>
              <p>{{ isChinese ? shengchanData.key2 : shengchanData.key2En }}</p>
            </div>
          </div>
          <div class="hoverBox_right">
            <div
              class="hoverBox_right_item"
              @mouseenter="showShengchan(item, index)"
              @mouseleave="closeShengchan(item, index)"
              v-for="(item, index) in shengchanList"
              :key="index"
            >
              <div
                :class="item.id2 === shengchanIndex ? 'huangbg' : 'huangbgNo'"
              >
                <p class="innerP hidenP">
                  {{ isChinese ? item.key : item.keyEn }}
                </p>
              </div>
              <p class="hidenP">{{ isChinese ? item.key : item.keyEn }}</p>
            </div>
          </div>
        </div>
      </template>
      <!-- 手机宽度下 轮播图改变 -->
      <template>
        <div class="phoneStyle">
          <el-carousel style="height: 100%">
            <el-carousel-item
              v-for="(item, index) in shengchanList"
              :key="index"
            >
              <img :src="item.value" alt="" />
              <div class="innerPhonestyleCon">
                <p>{{ isChinese ? item.key : item.keyEn }}</p>
                <div class="heng"></div>
                <p>
                  {{ isChinese ? item.key2 : item.key2En }}
                </p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </template>
    </div>
    <div class="section3">
      <div class="bbTitl">
        {{ isChinese ? section3Obj.context1 : section3Obj.context1En }}
      </div>
      <p class="pM">
        {{ isChinese ? section3Obj.context2 : section3Obj.context2En }}
      </p>
      <div class="wenhuaBox">
        <div class="wenhuaBox_top">
          <p
            v-for="(item, index) in wenhuaList"
            @mouseenter="showWenhua(item, index)"
            @mouseleave="closeWenhua(item, index)"
            :class="item.id2 === wenhuaIndex ? 'huangbg2' : ''"
            :key="index"
          >
            {{ isChinese ? item.key : item.keyEn }}
          </p>
        </div>
        <div class="wenhuaBox_bottom">
          <img :src="wenhuaImg" alt />
        </div>
      </div>
    </div>

    <div class="section4">
      <p class="bbTitl titl">
        {{ isChinese ? section4Obj.context1 : section4Obj.context1En }}
      </p>
      <p class="section4_p">
        {{ isChinese ? section4Obj.context2 : section4Obj.context2En }}
      </p>
      <!-- 轮播图 -->
      <div class="lunboBox">
        <div class="left_carousel_btn carBtn" v-if="!isPhone">
          <img
            src="../../static/images/aboutUs/GYWM-16.png"
            alt=""
            style="width: 57px; height: auto"
          />
        </div>

        <div
          class="outSideAllow"
          :class="isPhone ? 'isPhoneWidth' : 'isPCWidth'"
        >
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in QCList"
                :key="index"
              >
                <div class="hover_box">
                  <img :src="item.value" alt="" />
                  <div class="innerHoverDiv">
                    {{ isChinese ? item.key : item.keyEn }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="right_carousel_btn carBtn"
          slot="button-next"
          v-if="!isPhone"
        >
          <img
            src="../../static/images/aboutUs/GYWM-17.png"
            alt=""
            style="width: 57px; height: auto"
          />
        </div>
      </div>
    </div>
    <div class="section5">
      <p class="bbTitl section5_tit">
        {{ isChinese ? "合作涂料品牌" : "Cooperative Coatings Band" }}
      </p>
      <div class="hezuoBox">
        <img
          style="object-fit: cover"
          src="../../static/images/aboutUs/GYWM-18.jpg"
          alt
        />
      </div>
      <div class="hezuoBox_imgbox">
        <div>
          <div
            v-for="(item, index) in hezuoList"
            class="hezuoBox_imgbox_inner"
            style="cursor: pointer"
            @click="goto(item.url)"
            :key="index"
          >
            <div>
              <img :src="item.topImg" alt />
            </div>
            <div>
              <img class="hezuoBox_imgbox_inner_img" :src="item.bottom" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section6">
      <div class="bbTitl">
        {{
          isChinese
            ? "公司服务的终端客户"
            : "End Customers Served By The Company"
        }}
      </div>
      <div class="section6ImgBox">
        <img :src="companyServesImg" alt />
      </div>
    </div>
    <div class="section7">
      <!-- <img src="../../static/images/aboutUs/GYWM-26.jpg" alt /> -->
      <div class="section7_innertext section7_innertext_1">
        <div class="bbTitl">
          {{ isChinese ? section6Obj.context1 : section6Obj.context1En }}
        </div>
        <p class="section9_color">
          {{ isChinese ? section6Obj.context2 : section6Obj.context2En }}
        </p>
      </div>
    </div>

    <div class="section8">
      <div class="section8_box">
        <div
          v-for="(item, index) in xiazaiList"
          class="section8_flex"
          style="cursor: pointer"
          @click="downfile(item.value)"
          :key="index"
        >
          <div>
            <img src="../../static/images/aboutUs/GYWM-27.jpg" alt />
          </div>
          <div class="pBox">
            <p>{{ isChinese ? item.key : item.keyEn }}</p>
            <!-- <p>{{ item.key }}</p> -->
          </div>
        </div>
      </div>
    </div>

    <div class="section7 section9">
      <div class="section7_innertext section7_innertext_2 section9_innertext">
        <div class="bbTitl_white">
          {{ isChinese ? section7Obj.context1 : section7Obj.context1En }}
        </div>
        <p class="section9_color section9_color_white">
          {{ isChinese ? section7Obj.context2 : section7Obj.context2En }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  name: "aboutUs",
  data() {
    return {
      isPhone: false,
      bgImg: "",
      isChinese: undefined,
      context1: 1990,
      context2: 500,
      context3: 5,
      shengchanImg: "", // 默认是shengchanList的第一个
      shengchanIndex: 0,
      shengchanData: {},
      shengchanList: [],
      shengchanTimer: {},
      wenhuaImg: "",
      wenhuaIndex: 0,
      wenhuaList: [],
      hezuoList: [
        {
          topImg: require("../../static/images/aboutUs/GYWM-22.jpg"),
          bottom: require("../../static/images/aboutUs/GYWM-19.jpg"),
          url: "http://www.nofmetalcoatings.com",
        },
        {
          topImg: require("../../static/images/aboutUs/GYWM-23.jpg"),
          bottom: require("../../static/images/aboutUs/GYWM-20.jpg"),
          url: "https://magnicoatings.com",
        },
        {
          topImg: require("../../static/images/aboutUs/GYWM-24.jpg"),
          bottom: require("../../static/images/aboutUs/GYWM-21.jpg"),
          url: "http://www.atotech.com.cn",
        },
      ],
      QCList: [],
      section1Obj: {},
      section3Obj: {}, // 企业文化
      section4Obj: {}, // Qc实验室
      section6Obj: {}, // 认证资质对象
      section7Obj: {}, // 环境友好型对象
      xiazaiList: [], // 下载
      companyServesImg: "",
      scrollLeft: 1500,
    };
  },
  components: { countTo, Swiper },

  created() {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.isPhone = true;
    } else {
      this.isPhone = false;
    }
    this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
    this.getDownFileList();
    this.getTopImg();
    this.getSection1Data();
    this.getSection3Data();
    this.getSection4Data();
    this.getSection5Data();
    this.getSection6Data();
    this.getSection7Data();
    this.getSection9Data();
    // var swiper = new Swiper(".multiple-banner", {
    //   slidesPerView: 1,
    //   spaceBetween: 30,
    //   loop: true,
    //   navigation: {
    //     nextEl: ".right_carousel_btn",
    //     prevEl: ".left_carousel_btn",
    //   },
    // });
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      pagination: ".swiper-pagination",
      paginationClickable: true,
      slidesPerView: 3,
      spaceBetween: this.isPhone ? 2 : 40,
      speed: 600,
      autoplay: 4000,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
    });
    $(".left_carousel_btn").click(function () {
      swiper.slidePrev();
    });
    $(".right_carousel_btn").click(function () {
      swiper.slideNext();
    });
  },
  computed: {
    setCAE() {
      return this.$store.state.cAeSatus;
    },
  },
  watch: {
    //监听路由变化
    setCAE(newVal) {
      this.isChinese = newVal === 1 ? true : false;
    },
  },
  methods: {
    nextLunbo() {
      this.$refs.lunbo.next();
    },
    preLunbo() {
      this.$refs.lunbo.prev();
    },
    goto(routerUrl) {
      window.open(routerUrl, "_blank");
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum.start();
          this.$refs.mynum1.start();
          this.$refs.mynum2.start();
        },
        {
          offset: "20%",
        }
      );
    },
    showShengchan(data, index) {
      this.shengchanIndex = index;
      this.shengchanImg = data.value;
      this.shengchanData = data;
    },
    getDownFileList() {
      this.$http
        .get("/jishi/api/files/list", {
          params: {
            type: 1,
            page: 1,
            limit: 30,
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.page;
              this.xiazaiList = resdata.list;
            }
          }.bind(this)
        );
    },
    downfile(url) {
      window.open(url, "_blank");
    },
    closeShengchan(data, index) {
      this.shengchanIndex = index;
      this.shengchanImg = data.value;
      this.shengchanData = data;
    },
    showWenhua(data, index) {
      this.wenhuaIndex = index;
      this.wenhuaImg = data.value;
    },
    closeWenhua(data, index) {
      this.wenhuaIndex = index;
      this.wenhuaImg = data.value;
    },
    getTopImg() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "关于计氏-顶部图片",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              this.bgImg = resdata.logo;
            }
          }.bind(this)
        );
    },
    getSection1Data() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "关于计氏-介绍",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              this.section1Obj = resdata;
            }
          }.bind(this)
        );
    },
    getSection3Data() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "关于计氏-企业文化",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data.pictureJSONArray;
              this.section3Obj = res.data.data;
              resdata.forEach((item, index) => {
                item.id2 = index;
              });
              this.wenhuaList = resdata;
              this.wenhuaImg = resdata[0].value;
            }
          }.bind(this)
        );
    },
    getSection9Data() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "关于我们-公司服务的终端客户",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              this.companyServesImg = resdata.logo;
            }
          }.bind(this)
        );
    },
    getSection4Data() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "关于计氏-我们的生产基地",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data.pictureJSONArray;
              resdata.forEach((item, index) => {
                item.id2 = index;
              });
              this.shengchanList = resdata;
              this.shengchanData = this.shengchanList[0];
              this.shengchanImg = this.shengchanList[0].value;
            }
          }.bind(this)
        );
    },
    getSection5Data() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "关于计氏-QC实验室-Banner",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              //  处理关于我们 展示三张的 轮播图
              this.section4Obj = resdata;
              let qclist = resdata.pictureJSONArray;
              let result = [];
              // for (let i = 0; i < qclist.length; i += 3) {
              //   result.push(qclist.slice(i, i + 3));
              // }
              for (let i = 0; i < qclist.length; i++) {
                result.push(qclist[i]);
              }
              this.QCList = result;
              console.log(this.QCList);
            }
          }.bind(this)
        );
    },
    getSection6Data() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "关于计氏-认证资质",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              this.section6Obj = resdata;
            }
          }.bind(this)
        );
    },
    getSection7Data() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "关于计氏-环境友好型企业",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.data;
              this.section7Obj = resdata;
            }
          }.bind(this)
        );
    },
  },
};
</script>

<style lang="stylus" scoped>
#marquee-box {
  width: 100%;
  overflow: hidden;
  /* height: auto; */
}

#marquee-con {
  width: 300%;
  float: left;
  /* height: auto; */
}

#marquee, #marquee-1 {
  float: left;
}

.marquee-img {
  float: left;
  height: 100%;
  width: 100%;
  margin-left: 16px;
  object-fit: cover;
}

// .swiper-container {
// width: 100%;
// height: 100%;
// }

// .swiper-slide {
// text-align: center;
// font-size: 18px;
// background: #fff;
// /* Center slide text vertically */
// display: -webkit-box;
// display: -ms-flexbox;
// display: -webkit-flex;
// display: flex;
// -webkit-box-pack: center;
// -ms-flex-pack: center;
// -webkit-justify-content: center;
// justify-content: center;
// -webkit-box-align: center;
// -ms-flex-align: center;
// -webkit-align-items: center;
// align-items: center;
// }

// .swiper-slide img {
// display: block;
// width: 100%;
// height: 100%;
// object-fit: cover;
// }

// .swiper-slide {
// width: 30%;
// height:50rem;
// }
* {
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  height: 100%;
}

.section1 {
  position: relative;
  width: 100%;
}

.auBox {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 7rem;
}

@media (max-width: 800px) {
  .auBox {
    font-size: 30px;
  }

  .section2 > p {
    width: 90% !important;
  }

  #marquee-box {
    width: 100%;
    overflow: hidden;
    /* height: auto; */
  }

  #marquee-con {
    width: 300%;
    float: left;
    /* height: auto; */
  }

  #marquee, #marquee-1 {
    float: left;
  }

  .marquee-img {
    float: left;
    height: 122px;
    width: 106px;
    margin-left: 16px;
  }

  /* .section2 > p {
    width: 90% !important;
    font-size: 24px !important;
  } */
}

.section2 > p {
  margin: 0 auto;
  text-align: center;
  width: 60%;
  color: #9b9696;
  font-size: 15px;
}

.section2 > p:nth-child(1) {
  width: 40%;
  color: #595757;
  font-size: 3rem;
  margin-top: 6vw;
  font-family: Medium;
}

.section2 > p:nth-child(2) {
  line-height: 30px;
  margin-top: 2vw;
}

.section2 > p:nth-child(3) {
  margin-top: 2vw;
  line-height: 30px;
}

.scrllrBox {
  display: flex;
  align-items: center;
  width: 60%;
  margin: 0 auto;
  justify-content: space-around;
  margin-top: 3vw;
}

.scrllrBox > div {
  text-align: center;
}

.scrllrBox > div > p:nth-child(1) {
  color: #edac1a;
  font-family: Bold;
  font-size: 4.5rem;
}

.scrllrBox > div > p:nth-child(2) {
  margin-top: 10px;
  font-size: 1.6rem;
  color: #5e5c5c;
}

@media (max-width: 800px) {
  .scrllrBox > div > p:nth-child(1) {
    font-size: 18px;
  }

  .scrllrBox > div > p:nth-child(2) {
    font-size: 14px;
  }
}

.shu {
  display: inline-block;
  width: 1px;
  height: 5vw;
  background: black;
}

.section3 {
  margin-top: 6vw;
  text-align: center;
}

.hoverBox {
  display: flex;
  width: 60%;
  margin: 0 auto;
  margin-top: 3vw;
}

.hoverBox_left {
  width: 70%;
  height: 30vw;
  position: relative;
}

.phoneStyle {
  display: none;
}

@media (max-width: 900px) {
  .hoverBox {
    display: none;
  }

  .phoneStyle {
    display: block;
    width: 95vw;
    height: 55vw;
    margin: 0 auto;
    margin-top: 10px;
  }

  .innerPhonestyleCon {
    position: absolute;
    top: 20px;
    left: 20px;
    color: white;
    text-align: left;
  }

  .wenhuaBox_top {
    width: 95% !important;
  }

  .wenhuaBox_top > p {
    padding: 1vh 0 !important;
  }

  .section4_p {
    width: 95% !important;
    line-height: 20px !important;
    font-size: 13px !important;
  }
}

.innerText {
  position: absolute;
  top: 2vw;
  left: 2vw;
}

.heng {
  width: 2.5vw;
  height: 2px;
  background: white;
  margin: 8px 0;
}

.innerText > p {
  text-align: left;
  color: white;
}

.innerText > p:nth-child(1) {
  font-size: 1.6rem;
}

.innerText > p:nth-child(2) {
  font-size: 1.2rem;
}

.hoverBox_right {
  width: 30%;
  border-left: 1px solid white;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
}

.hoverBox_right_item {
  position: relative;
  background: #595757;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.innerP {
  position: absolute;
  display: flex;
  width: 92%;
  right: 0;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.hidenP {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.huangbg {
  background: #f7b100;
  height: 100%;
  width: 110%;
  position: absolute;
  top: 0;
  right: 0;
}

.huangbgNo {
  display: none;
}

.bbTitl {
  text-align: center;
  color: #595757;
  font-size: 3rem;
  font-family: Medium;
}

.bbTitl_white {
  text-align: center;
  color: white !important;
  font-size: 3rem;
  font-family: Medium;
}

.pM {
  margin: 0 auto;
  text-align: center;
  width: 60%;
  color: #9b9696;
  font-size: 1.4rem;
  margin-top: 2vw;
}

.wenhuaBox {
  margin-top: 3vw;
  border-top: 1px solid #ddd;
  position: relative;
}

.wenhuaBox_top {
  width: 60%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: -1px;
}

.wenhuaBox_top > p {
  border-right: 1px solid;
  border-bottom: 1px solid;
  font-size: 1.5rem;
  width: 100%;
  padding: 1.8vh 0;
  background: #606060;
  color: white;
  cursor: pointer;
}

.huangbg2 {
  background: #f7b100 !important;
}

.wenhuaBox_bottom {
  width: 100%;
  height: 33vw;
  overflow: hidden;
}

.section4 {
  width: 100%;
  height: auto;
  background: #3c3c3b;
  color: white;
  text-align: center;
  position: relative;
}

.titl {
  color: white;
  margin-top: 4vw;
  padding-top: 6vw;
  padding-bottom: 2vw;
}

.section4_p {
  width: 60%;
  margin: 0 auto;
  color: #c5c5c5;
  line-height: 30px;
  padding-bottom: 15vw;
  font-size: 15px;
}

.lunboBox {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 21.5vw;
  position: absolute;
  padding: 0;
  margin: 0;
  bottom: -8vw;
}

.carBtn {
  position: absolute;
  width: 57px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.left_carousel_btn {
  left: 10vw;
}

.right_carousel_btn {
  right: 10vw;
}

.lunboBox .outSideAllow {
  width: 60%;
  height: 100%;
}

.lunboImg {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0;
  padding: 0;
}

.innerCar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0;
  padding: 0;
}

.innerCar > div {
  flex: 1;
  margin-left: 5px;
}

.multiple-banner {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
}

.innerImg {
  height: 50rem;
  margin-left: auto;
  margin-right: auto;
}
</style>
<style scoped>
.section5 {
  margin-top: 18vw;
  position: relative;
}
.section5_tit {
  position: absolute;
  width: 100%;
  color: white;
  text-align: center;
  top: 10vw;
}
.hezuoBox {
  width: 100%;
  height: 30vw;
}
.hezuoBox_imgbox {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 26vw;
  bottom: -15vw;
}
.hezuoBox_imgbox > div {
  width: 60%;
  height: 30vw;
  display: flex;
  align-items: center;
}
.hezuoBox_imgbox_inner {
  flex: 1;
  background: white;
  display: flex;
  height: 100%;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
}

.hezuoBox_imgbox_inner > div:nth-child(1) {
  width: 60%;
  height: 6vw;
  line-height: 6vw;
  display: flex;
  align-items: center;
}
.hezuoBox_imgbox_inner > div:nth-child(1) img {
  width: 100%;
  height: auto;
}
.hezuoBox_imgbox_inner > div:nth-child(2) {
  width: 73%;
  height: 17.5vw;
  margin-top: 2vw;
}

.section6 {
  margin-top: 26vw;
}
.section6ImgBox {
  width: 60%;
  height: auto;
  margin: 0 auto;
  margin-top: 3vw;
}
.section6ImgBox img {
  width: 100%;
  height: auto;
}
.section7 {
  width: 100%;
  margin-top: 3vw;
  position: relative;
}
.section7_innertext {
  width: 100%;
  height: 30vw;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.section7_innertext_1 {
  background: url("../../static/images/aboutUs/GYWM-26.jpg") no-repeat;
  background-size: cover;
  /* background-image: url('../../static/images/aboutUs/GYWM-26.jpg'); */
  /* object-fit: cover; */
}
.section7_innertext_2 {
  background: url("../../static/images/aboutUs/GYWM-28.jpeg") no-repeat;
  /* background-size:100% 100%; */
  background-size: cover;
}
.section7_innertext > div {
  color: black;
}
.section7_innertext > p {
  width: 60%;
  line-height: 30px;
  margin-top: 2vw;
  color: black;
}

.section8 {
  display: none;
  width: 100%;
  padding: 4vw 0;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}
.section8_box {
  width: 60%;
  display: flex;
  flex-wrap: wrap;
}
.section8_box > div {
  width: 40%;
  display: flex;
  align-items: center;
}
.section8_flex {
  margin: 10px 0 0 30px;
  padding: 5px;
  background: #f7f6f4;
  width: 100%;
  height: 100%;
}
.section8_flex > div:nth-child(1) {
  width: 2vw;
}
.section8_flex > div:nth-child(2) {
  flex: 1;
}
.pBox > p {
  height: 2.3vw;
  line-height: 2.3vw;
  width: 90%;
  background: #f7f6f4;
  padding-left: 1vw;
  color: #949494;
  font-size: 15px;
}
.section9_color {
  text-align: center;
  font-size: 15px;
  /* color: white !important; */
}
.section9_color_white {
  color: white !important;
}

.hover_box {
  position: relative;
  cursor: pointer;
}
.innerHoverDiv {
  font-size: 15px;
  visibility: hidden;
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #f7b100;
  color: white;
  z-index: 999;
  height: 60px;
  line-height: 60px;
}
.hover_box:hover .innerHoverDiv {
  visibility: visible;
}
.hover_box img {
  z-index: 1;
  width: 100%;
  height: 100%;
}
.outSideAllow >>> .el-carousel__arrow {
  display: none;
}
@media (max-width: 900px) {
  .bbTitl,
  .titl,
  .section2 > p:nth-child(1) {
    font-size: 20px;
  }
  .bbTitl_white {
    font-size: 20px;
  }

  .section9_color,
  .section4_p,
  .section2 > p:nth-child(2),
  .section2 > p:nth-child(3) {
    font-size: 13px;
    line-height: 20px;
    margin-top: 4vw;
  }
  .section7_innertext > p {
    width: 90%;
    height: 100%;
    line-height: 20px;
    font-size: 13px;
  }
  .section7_innertext {
    height: 100%;
    padding: 20px 0;
  }
  .scrllrBox {
    width: 95%;
  }
  .left_carousel_btn {
    display: none;
  }
  .right_carousel_btn {
    display: none;
  }
  .lunboBox {
    height: 30vw;
    bottom: -18vw;
  }
  .lunboBox .outSideAllow {
    width: 90%;
  }
  .section5 {
    margin-top: 25vw;
  }
  .hezuoBox {
    height: 50vw;
  }
  .hezuoBox_imgbox {
    bottom: 0vw;
  }
  .hezuoBox_imgbox > div {
    width: 90%;
    height: 30vw;
  }
  /* .hezuoBox_imgbox_inner{
    margin-left: 2px;
    height: 30vw;
    align-items: stretch;
  } */
  /* .hezuoBox_imgbox_inner > div{
    height: auto !important;
    line-height: 1vw !important;
  } */
  .hezuoBox_imgbox_inner_img {
    /* background-size: auto 8vw !important; */
    /* object-fit: cover !important; */
    margin-left: 1vw;
    height: 25vw !important;
    width: auto !important;
  }
  .section6 {
    margin-top: 25vw;
  }
  .section6ImgBox {
    width: 90%;
  }
  .section7 {
    height: auto;
  }

  .section8 {
    height: 60vw;
  }

  .section9 {
    height: auto;
  }

  .innerHoverDiv {
    font-size: 10px;
    height: 30px;
    line-height: 30px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/aboutUs.vue